export const blogEmpresarialTemas = [
  { label: "Administración", slug: "gestion-administrativa", icon: "briefcase" },
  { label: "Comercio internacional", slug: "estrategia-comercial", icon: "globe" },
  { label: "E-commerce", slug: "estrategia-comercial", icon: "shopping-cart" },
  { label: "Emprendimiento", slug: "estrategia-comercial", icon: "rocket" },
  { label: "Finanzas empresariales", slug: "finanzas-corporativas", icon: "wallet" },
  { label: "Gestión empresarial", slug: "gestion-administrativa", icon: "building" },
  { label: "Gestión de riesgo", slug: "finanzas-corporativas", icon: "shield" },
  { label: "Gestión de procesos", slug: "transformacion-digital", icon: "workflow" },
  { label: "Gestión humana", slug: "gestion-administrativa", icon: "users" },
  { label: "Innovación", slug: "transformacion-digital", icon: "lightbulb" },
  { label: "Legal", slug: "gestion-administrativa", icon: "scale" },
  { label: "Seguros", slug: "finanzas-corporativas", icon: "shield" },
  { label: "Datos y analítica", slug: "transformacion-digital", icon: "workflow" },
];
